import { z, TypeOf } from 'zod';

export const productImage = z.object({
    url: z.string(),
    width: z.number().optional(),
    height: z.number().optional(),
    altText: z.string().optional()
});

export const productOption = z.object({
    name: z.string(),
    values: z.array(z.string()),
    position: z.number().optional()
});

export const productVariantSelectedOption = z.object({
    name: z.string(),
    value: z.string()
});

export const productVariant = z.object({
    variantId: z.string(),
    variantName: z.string(),
    selectedOptions: z.array(productVariantSelectedOption),
    url: z.string(),
    unitPrice: z.number(),
    images: z.array(productImage),
    available: z.boolean(),
    productName: z.string().optional(),
    unitPriceOriginal: z.number().optional(),
    discountedAmount: z.number().optional(),
    discountedPercentage: z.number().optional(),
    quantityInStock: z.number().optional()
});

export const product = z.object({
    id: z.string(),
    currency: z.string(),
    locale: z.string(),
    productId: z.string(),
    url: z.string(),
    name: z.string(),
    unitPrice: z.number(),
    available: z.boolean(),
    handle: z.string(),
    images: z.array(productImage),
    options: z.array(productOption),
    variants: z.array(productVariant),
    taxonomyTags: z.array(z.string()),
    unitPriceOriginal: z.number().optional(),
    discountedAmount: z.number().optional(),
    discountedPercentage: z.number().optional(),
    ratingCount: z.number().optional(),
    ratingValue: z.number().optional(),
    brand: z.string().optional(),
    category: z.string().optional(),
    rank: z.number().optional(),
    smartFilters: z.record(z.boolean()).optional(),
    summaryDescription: z.string().optional(),
    localizedDescription: z.string().optional(),
    relatedAnalysisQuestions: z.array(z.string()).optional(),
    relatedComparisonQuestions: z.array(z.string()).optional()
});
export type Product = TypeOf<typeof product>;
export type ProductVariant = TypeOf<typeof productVariant>;
